// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"33a8fadb","378":"d7624159","453":"47b211dc","497":"bcdddabb","726":"f458fb75"}[chunkId] + ".chunk.js";
};